import { SbExamplerModule } from '../exampler/sb-exampler.module';
import { SbWrapperModule } from '../wrapper/sb-wrapper.module';
import { SbCodeModule } from '../code/sb-code.module';
import { moduleMetadata, storiesOf } from '@storybook/angular';
import { StoryFn, StoryKind, StoryName } from '@storybook/addons';

export declare type StoryOptions = {
  storiesOf: StoryKind;
  name: StoryName;
  storyFn: StoryFn;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Story(options: StoryOptions): ClassDecorator {
  return (target: any): void => {
    storiesOf(options.storiesOf, module)
      .addDecorator(
        moduleMetadata({
          imports: [
            SbExamplerModule,
            SbWrapperModule,
            SbCodeModule,
            target,
          ],
        }))
      .add(options.name, options.storyFn);
    return target;
  };
}
